function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props), React.createElement("path", {
  d: "M5.13 0h5.74c1.79 0 2.43.19 3.08.53a3.6 3.6 0 011.52 1.52c.34.65.53 1.3.53 3.08v5.74c0 1.79-.19 2.43-.53 3.08a3.63 3.63 0 01-1.52 1.52c-.65.34-1.3.53-3.08.53H5.13c-1.79 0-2.43-.19-3.08-.53a3.63 3.63 0 01-1.52-1.52C.2 13.3 0 12.65 0 10.87V5.13C0 3.34.19 2.7.53 2.05.88 1.39 1.4.88 2.05.53 2.7.2 3.35 0 5.13 0zM9 11a1 1 0 100 2h3a1 1 0 100-2H9zM8 9a1 1 0 00-.36-.77L4.7 5.29A1 1 0 003.3 6.7L5.59 9l-2.3 2.3a1 1 0 001.41 1.4l2.94-2.93A1.01 1.01 0 008 9z"
})));